import { gql } from '@apollo/client';

const CATALOG_PLAN_FRAGMENT = gql`
  fragment CatalogPlanFull on MerchantCatalogPlanObject {
    id
    digitalCardId
    planCode
    status
    isTrialActive
    trialStartedAt
    trialEndsAt
    currentPeriodStart
    currentPeriodEnd
    cancelAtPeriodEnd
    canceledAt
    billingCountry
    billingCurrency
    referralsEarned
    referralBonusProducts
    hasReferralPhotoBonus
    createdAt
    updatedAt
  }
`;

export const ADMIN_GET_MERCHANT_CATALOG_PLANS = gql`
  ${CATALOG_PLAN_FRAGMENT}
  query AdminGetMerchantCatalogPlans(
    $page: Int
    $pageSize: Int
    $planCode: String
    $status: String
    $search: String
  ) {
    adminMerchantCatalogPlans(
      page: $page
      pageSize: $pageSize
      planCode: $planCode
      status: $status
      search: $search
    ) {
      total
      page
      pageSize
      items {
        ...CatalogPlanFull
        digitalCard {
          id
          displayName
          slug
          cardType
          user {
            id
            firstName
            lastName
            email
            phoneNumber
          }
        }
        referralCode {
          code
          totalClicks
          totalSignups
          totalEarned
        }
      }
    }
  }
`;

export const ADMIN_GET_MERCHANT_CATALOG_PLAN = gql`
  ${CATALOG_PLAN_FRAGMENT}
  query AdminGetMerchantCatalogPlan($id: String!) {
    adminMerchantCatalogPlan(id: $id) {
      ...CatalogPlanFull
      digitalCard {
        id
        displayName
        slug
        cardType
        user {
          id
          firstName
          lastName
          email
          phoneNumber
        }
      }
      referralCode {
        code
        totalClicks
        totalSignups
        totalEarned
        referrals {
          id
          status
          createdAt
          rewardedAt
          referred {
            id
            firstName
            lastName
            email
          }
        }
      }
    }
  }
`;

export const ADMIN_GET_MERCHANT_CATALOG_PLAN_STATS = gql`
  query AdminGetMerchantCatalogPlanStats {
    adminMerchantCatalogPlanStats {
      total
      byStatus
      byPlanCode
      activeTrials
      trialConversionRate
    }
  }
`;

export const ADMIN_FORCE_DOWNGRADE_CATALOG_PLAN = gql`
  mutation AdminForceDowngradeCatalogPlan($planId: String!, $reason: String!) {
    adminForceDowngradeCatalogPlan(planId: $planId, reason: $reason) {
      id
      planCode
      status
    }
  }
`;

export const ADMIN_CANCEL_CATALOG_PLAN = gql`
  mutation AdminCancelCatalogPlan($planId: String!, $reason: String!) {
    adminCancelCatalogPlan(planId: $planId, reason: $reason) {
      id
      status
      canceledAt
    }
  }
`;
